import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomeCardView = style({
    display: 'inline-block',
    paddingLeft: 15,
    paddingRight: 15
})

export const titleName = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    paddingBottom: 14,
    paddingTop: 14,
    paddingLeft: 15
})

export const HomeCardViewItemWrap = style({
    ...csstips.flexRoot,
    ...csstips.wrap,
    ...csstips.betweenJustified,
    width: '100%',
    paddingLeft: 15,
    paddingRight: 15
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeCardView/HomeCardView.style.ts